/**
 * El identificador del dispositivo.
 *
 * Es la pieza que distingue «he recargado la página» de «he abierto mi cuenta en otro sitio»: dos
 * cosas que, vistas desde el servidor, son idénticas —una conexión nueva con la misma identidad—.
 * Sin él, recargar expulsaría a quien recarga, y en un aula con cuarenta móviles y la wifi del
 * centro eso ocurre continuamente.
 *
 * Vive en `localStorage` porque tiene que **sobrevivir a la recarga**, que es justo el caso que
 * distingue. En `sessionStorage` no serviría de nada: una pestaña nueva sería otro dispositivo.
 */

const KEY = 'clica.deviceId';

export function readDeviceId(storage: Storage = window.localStorage): string {
  try {
    const existing = storage.getItem(KEY);
    if (existing !== null && existing.length >= 8) return existing;

    const fresh = crypto.randomUUID();
    storage.setItem(KEY, fresh);
    return fresh;
  } catch {
    // Modo privado, almacenamiento lleno o bloqueado por el navegador. Se sigue con uno de usar y
    // tirar: la persona pierde la ventaja de la recarga silenciosa, pero puede jugar.
    return crypto.randomUUID();
  }
}
